// API Configuration using environment variables
const API_CONFIG = {
  development: {
    graphqlUrl: process.env.REACT_APP_GRAPHQL_URL,
    uploadUrl: process.env.REACT_APP_UPLOAD_URL,
  },
  qa: {
    graphqlUrl: process.env.REACT_APP_GRAPHQL_URL,
    uploadUrl: process.env.REACT_APP_UPLOAD_URL,
  },
  uat: {
    graphqlUrl: process.env.REACT_APP_GRAPHQL_URL,
    uploadUrl: process.env.REACT_APP_UPLOAD_URL,
  },
  production: {
    graphqlUrl: process.env.REACT_APP_GRAPHQL_URL,
    uploadUrl: process.env.REACT_APP_UPLOAD_URL,
  }
};

// Get current environment
const getEnvironment = () => {
  return process.env.REACT_APP_ENV || 'development';
};

// Get current API config
export const getApiConfig = () => {
  const env = getEnvironment();
  return API_CONFIG[env] || API_CONFIG.development;
};

// Export individual configs for convenience
export const GRAPHQL_URL = getApiConfig().graphqlUrl;
export const UPLOAD_URL = getApiConfig().uploadUrl;

// GraphQL endpoints
export const GRAPHQL_ENDPOINTS = {
  GRAPHQL: GRAPHQL_URL,
  UPLOAD: UPLOAD_URL,
};

export default API_CONFIG; 